import { axiosClient } from 'api/api';

export type QueryMessage = {
  id: number;
  sender_role: 'admin' | 'user';
  sender_id: number;
  body: string;
  created_at: string;
  email_state: 'not_required' | 'sending' | 'sent' | 'review';
};

export type UserQuery = {
  messages?: QueryMessage[];
  /** Screenshot URLs uploaded with the original query (concerns only; sent with the conversation). */
  attachments?: string[];
  ticket_status?: string;
  status_editable?: number | boolean;
  id: number;
  source: 'concern' | 'feedback';
  user_name: string;
  email: string;
  message: string;
  feedback_type: string;
  created_at: string;
  reply_state: 'unreplied' | 'sending' | 'review' | 'sent';
  admin_reply: string | null;
  replied_at: string | null;
  replied_by: number | null;
};
export async function getQueryConversation(query: UserQuery, admin: boolean): Promise<UserQuery> {
  return (await axiosClient.get(`/api/${admin ? 'admin/user-queries' : 'my-queries'}/${query.source}/${query.id}/conversation`)).data.result;
}
export async function sendQueryMessage(query: UserQuery, reply: string, clientId: string, admin: boolean): Promise<UserQuery> {
  return (await axiosClient.post(`/api/${admin ? 'admin/user-queries' : 'my-queries'}/${query.source}/${query.id}/reply`, { reply, clientId })).data.result;
}
export async function setQueryStatus(query: UserQuery, status: string): Promise<UserQuery> {
  return (await axiosClient.post(`/api/admin/user-queries/${query.source}/${query.id}/status`, { status })).data.result;
}
export async function listUserQueries(page: number, search = ''): Promise<{ queries: UserQuery[]; hasMore: boolean }> {
  return (await axiosClient.get('/api/admin/user-queries', { params: { page, search } })).data.result;
}
